import { createFormDataRequest } from "@/helpers/FormHelpers";
import { CompanyCoursePersonFormSend } from "@/interfaces/CompanyCourse";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Person from "@/interfaces/Person";
import api from "@/services/api";

export const companyCoursePeopleApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyCoursePeople: build.query<
      IPaginateResponse<Person>,
      [string, string, IFilters]
    >({
      query: ([id, courseId, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/companies/${id}/courses/${courseId}/people`,
          params,
        };
      },
      providesTags: (result, _error, [companyId, courseId]) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyCoursePeople" as const,
                companyId,
                courseId,
                id,
              })),
              { type: "CompanyCoursePeople", companyId, courseId, id: "LIST" },
            ]
          : [],
    }),
    deleteCompanyCoursePerson: build.mutation<void, [string, string, string]>({
      query: ([companyId, courseId, personId]) => ({
        url: `/companies/${companyId}/courses/${courseId}/people/${personId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCoursePeople", companyId, courseId, id: "LIST" },
      ],
    }),
    storeCompanyCoursePerson: build.mutation<
      Person,
      [string, string, CompanyCoursePersonFormSend]
    >({
      query: ([companyId, courseId, body]) => ({
        url: `/companies/${companyId}/courses/${courseId}/people`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCoursePeople", companyId, courseId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCompanyCoursePeopleQuery,
  useDeleteCompanyCoursePersonMutation,
  useStoreCompanyCoursePersonMutation,
} = companyCoursePeopleApi;
